module.exports = __webpack_public_path__ + "img/icon5.ae3a5b30.svg";